import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { User } from '../_models/user';

@Injectable({ providedIn: 'root' })
export class UserService {

    private currentUser : any;

    constructor(private http: HttpClient) { }

    getCurrentUserData() {
        return this.currentUser;
    }
}
